import Vue from 'vue';
import BaseInput from '../components/BaseInput';
import BaseButton from '../components/BaseButton';
import BaseCard from '../components/BaseCard';

Vue.component(BaseInput.name, BaseInput);
Vue.component(BaseButton.name, BaseButton);
Vue.component(BaseCard.name, BaseCard);